
import { Component, inject, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { OrganizationService } from 'src/app/private/services/organization.services';
import { LazyLoadEvent, MenuItem, } from 'primeng/api';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MenuModule } from 'primeng/menu';
import { CreateCampusComponent } from "../campus/create-campus/create-campus.component";
import { DeleteCampusComponent } from "../campus/delete-campus/delete-campus.component";

@Component({
  selector: 'app-campus-section',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    ToolbarModule,
    ButtonModule,
    DialogModule,
    InputTextModule, ButtonModule, ProgressSpinnerModule, MenuModule,
    CreateCampusComponent,
    DeleteCampusComponent
],
  templateUrl: './campus-section.component.html',
})
export class CampusComponent implements OnInit {
  @Input() orgId!: string;
  campuses: any[] = [];
  //totalRecords = 0;
  totalRecords: number = 0;

  rows = 10;
  //loading = false;
  loading: boolean = true;


  displayAddModal = false;
  addForm: FormGroup;

  selectedCampuses: any[] = [];
  actionItems: MenuItem[] = [];
  searchText: string = '';
  searchAttribute: string = 'name';
  campusDataToEdit: any = null; // To hold the campus data to be edited
  showEditCampus: boolean = false; // Flag to show the edit campus modal
  showDeleteCampus: boolean = false; // Flag to show the delete campus modal

  setCampusData(data: any) {
    this.campusDataToEdit = data;
  }

  campusActionItem: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Campus',
          icon: 'pi pi-fw pi-pencil',
          command: () => { 
            this.showEditCampus = true;
          }
        },
        {
          label: 'Delete Campus',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.showDeleteCampus = true;
          }
        }
      ]
    }
  ]

  constructor(
    private orgService: OrganizationService,
    private fb: FormBuilder
  ) {
    this.addForm = this.fb.group({
      organization_id: [this.orgId, Validators.required],
      name: ['', Validators.required],
      address: [''],
      city: [''],
      state: [''],
      country: [''],
      postal_code: [''],
      contact_number: [''],
      email: [''],
      website: [''],
      campus_type: [''],
      status: [''],
      code: ['']
    });
  }

  ngOnInit(): void {
  }


  openAddModal() {
    this.addForm.reset();
    this.addForm.patchValue({ organization_id: this.orgId });
    this.displayAddModal = true;
  }

  closeAddModal() {
    this.displayAddModal = false;
    this.addForm.reset();
  }

  saveCampus() {
    if (this.addForm.valid) {
      this.orgService.createCampus(this.addForm.value).subscribe(() => {
        this.loadCampuses({ first: 0, rows: this.rows });
        this.closeAddModal();
      });
    }
  }

  openMenu(event: MouseEvent, campus: any) {
    this.selectedCampuses = [campus];
    const menu = document.querySelector('p-menu') as any;
    menu?.toggle(event);
  }

  loadCampuses(event: any, searchValue?: string, searchAttribute?: string): void {
    this.loading = true;

    const payload = {
      organization_id: this.orgId
    };

    this.orgService.getAllCampus(payload).subscribe({
      next: (data) => {
        this.campuses = data  // Assuming the response has 'rows' property
        this.loading = false;
      },
      error: (err) => {
        console.error('❌ API Error:', err); // Log the error
        this.loading = false;
      }
    });
  }

  reload() {
    this.loadCampuses({ first: 0, rows: this.rows });
  }


  handleSearch() {
    this.loadCampuses({ first: 0, rows: this.rows }, this.searchText, this.searchAttribute);
  }



}